export default class ExportProjectFieldUpdate {
  constructor(fieldBindingKey, fieldValue, PrID = null) {
    this.fieldBindingKey = fieldBindingKey
    this.fieldValue = fieldValue
    this.PrID = PrID
  }
}
